var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWishcloud = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 76 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.75 18.195c-1.721.015-3.501.182-5.086.82a9.352 9.352 0 0 0 .688-3.657c-.015-5.235-4.247-9.515-9.392-9.515-3.066 0-5.953 1.531-7.73 4.098C40.87 5.84 34.648 0 27.589 0 13.757 0 11.26 14.825 13.757 19.013 9.091 17.77 0 21.03 0 31.123c0 7.147 6.91 11.806 12.845 13.036 6.251 1.29 36.115 2.853 49.904 0 5.204-1.077 12.801-4.432 12.801-12.975 0-7.132-6.52-13.021-12.8-12.99Z",
  fill: "#4397FF"
})));
export default SvgWishcloud;